import { render, staticRenderFns } from "./PorletCabecera.vue?vue&type=template&id=2b79908f&"
import script from "./PorletCabecera.vue?vue&type=script&lang=js&"
export * from "./PorletCabecera.vue?vue&type=script&lang=js&"
import style0 from "./PorletCabecera.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports